module.exports = __webpack_public_path__ + "static/media/arrow-blue-down.8621258e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/arrow-blue-down.svg
// module id = 1837
// module chunks = 0